import { render, staticRenderFns } from "./VDynamicGrid.vue?vue&type=template&id=384eb317&"
import script from "./VDynamicGrid.vue?vue&type=script&lang=ts&"
export * from "./VDynamicGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VDynamicGrid.vue?vue&type=style&index=0&id=384eb317&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports